import React, { ReactElement } from "react";
import { Global, css } from "@emotion/react";

export const CarouselCssOverrides = ({
  itemPadding,
  classSuffix,
}: {
  itemPadding: number;
  classSuffix?: string;
}): ReactElement => {
  /**
   * CSS override description:
   * - Supplementing missing styles for Carousel
   */

  return (
    <Global
      styles={css`
        .spark-carousel__item
          .spark-carousel__panel-custom-padding${classSuffix} {
          padding: ${itemPadding}px !important;
        }
      `}
    />
  );
};
